export const E2E_STORAGE_KEYS = {
	enabled: 'suigar.e2e.enabled',
	walletPrivateKey1: 'suigar.e2e.wallet.privateKey1',
	walletPrivateKey2: 'suigar.e2e.wallet.privateKey2',
} as const;

export type E2ETransactionRecord = {
	digest: string;
	source: 'signAndExecuteTransaction' | 'executeTransaction';
	timestamp: number;
};

export type E2ERuntimeState = {
	txs: E2ETransactionRecord[];
};

declare global {
	interface Window {
		__SUIGAR_E2E__?: E2ERuntimeState;
		__SUIGAR_E2E_WALLET_PRIVATE_KEYS__?: string[];
	}
}

export function isE2EAutomation(): boolean {
	if (typeof window === 'undefined') return false;
	return Boolean(window.navigator.webdriver);
}

export function isE2EEnabled(): boolean {
	if (typeof window === 'undefined') return false;
	return isE2EAutomation() && window.localStorage.getItem(E2E_STORAGE_KEYS.enabled) === '1';
}

export function applyE2EDocumentHints(): void {
	if (typeof document === 'undefined') return;
	if (!isE2EEnabled()) return;
	document.documentElement.dataset.e2e = 'true';
}

export function getE2EWalletPrivateKeys(): string[] {
	if (typeof window === 'undefined') return [];
	if (!isE2EEnabled()) return [];

	const injectedKeys = Array.isArray(window.__SUIGAR_E2E_WALLET_PRIVATE_KEYS__) ? window.__SUIGAR_E2E_WALLET_PRIVATE_KEYS__ : null;
	if (injectedKeys?.length) {
		return injectedKeys.map((value) => (typeof value === 'string' ? value.trim() : '')).filter(Boolean);
	}

	const candidates = [
		window.localStorage.getItem(E2E_STORAGE_KEYS.walletPrivateKey1),
		window.localStorage.getItem(E2E_STORAGE_KEYS.walletPrivateKey2),
	];
	return candidates.map((value) => value?.trim() ?? '').filter(Boolean);
}

export function recordE2ETransaction(record: Omit<E2ETransactionRecord, 'timestamp'> & { timestamp?: number }): void {
	if (typeof window === 'undefined') return;
	if (!isE2EEnabled()) return;

	const state = (window.__SUIGAR_E2E__ ??= { txs: [] });
	state.txs.push({ ...record, timestamp: record.timestamp ?? Date.now() });
}
